import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'

interface ServiceListSkeletonProps {
  count?: number
}

export function ServiceListSkeleton({ count = 3 }: ServiceListSkeletonProps) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      <Skeleton variant="text" width="35%" height={20} />
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={`skeleton-${index}`}
          sx={{
            py: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
            '&:last-of-type': { borderBottom: 'none', pb: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 1,
            }}
          >
            <Skeleton variant="text" width="50%" height={24} />
            <Skeleton variant="rounded" width={72} height={22} />
          </Box>
          <Skeleton variant="rounded" width={80} height={22} sx={{ mt: 0.5 }} />
          <Skeleton variant="text" width="30%" height={18} sx={{ mt: 1 }} />
          <Skeleton variant="text" width="25%" height={20} />
        </Box>
      ))}
    </Paper>
  )
}

ServiceListSkeleton.displayName = 'ServiceListSkeleton'
